import { connect } from 'react-redux'

import editor from 'shared/editor/utils'

import View from './view'

const perform = () => {
  return {
    onSelectEmoji: emoji => {
      if (emoji && editor.available()) {
        return editor.fire('emoji-insert', {
          emoji,
        })
      }
      return null
    },
  }
}

export default connect(null, perform)(View)
